module.exports = __webpack_public_path__ + "img/food-basics.267a6bf0.svg";